import React from 'react';
import { injectIntl } from "react-intl";
import axios from 'axios';
import { Typography } from '@material-ui/core';

import messages from "./messages";
import SearchComponent from '../../../common/elements/SearchComponent';

const CustomerSearch = props => {
  const {
    display = 'name',
    formikProps,
    intl: { formatMessage },
    label,
    name,
    onChange,
    onFocus,
  } = props;
  const { setFieldValue } = formikProps;

  const searchCustomer = value => {
    return axios.get('/api/v2/customers', {
      params: {
        all_customers: true,
        search: value,
      },
    });
  };

  const getFieldValue = option => {
    if (typeof option === 'object') {
      const {
        full_name,
        user: { phone_number },
      } = option;

      switch (display) {
        case 'name':
          return full_name;
        case 'phone':
          return phone_number;
        default:
          return option;
      }
    }
    return option;
  };

  return (
    <div>
      <SearchComponent
        formikProps={formikProps}
        onChange={(e, v) => {
          onChange ? onChange(e, v) : setFieldValue(name, v);
        }}
        onFocus={onFocus}
        handleSearch={searchCustomer}
        label={label}
        name={name}
        getOptionLabel={getFieldValue}
        renderOption={option => {
          const {
            full_name,
            user: { email, phone_number },
          } = option;
          return (
            <div>
              <div>{full_name}</div>
              <Typography color="textSecondary" variant="caption">
                <div>{formatMessage(messages.phoneNumber)}: {phone_number}</div>
                <div>{formatMessage(messages.email)}: {email}</div>
              </Typography>
            </div>
          );
        }}
        usePhoneNumberInput={display === 'phone'}
      />
    </div>
  );
};

export default injectIntl(CustomerSearch);
